import type { Locale } from '../../i18n';

/** `Intl` throws `RangeError` on an unparseable value rather than returning
 *  anything, so a single malformed timestamp would take down the whole screen
 *  that renders it. The raw string is worse to read and better than nothing. */
function format(value: string, options: Intl.DateTimeFormatOptions, locale: Locale): string {
  try {
    return new Intl.DateTimeFormat(locale, options).format(new Date(value));
  } catch {
    return value;
  }
}

/** A calendar date in the operator plane's one style. */
export function formatDate(iso: string, locale: Locale): string {
  return format(iso, { dateStyle: 'medium' }, locale);
}

/** A date-only `YYYY-MM-DD` (a usage `day`, a funded-window end), which `Date`
 * reads as UTC midnight: formatting it in the viewer's zone would print the
 * evening before wherever the offset is negative. */
export function formatCalendarDay(day: string, locale: Locale): string {
  return format(day, { dateStyle: 'medium', timeZone: 'UTC' }, locale);
}
